// extracted by mini-css-extract-plugin
module.exports = {"J_10":"J_J_10__oXtAh"};